/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { MultiplexOtc, MultiplexOtcInterface } from "../MultiplexOtc";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "expiry",
        type: "uint64",
      },
    ],
    name: "ExpiredOtcOrder",
    type: "event",
  },
  {
    inputs: [],
    name: "EIP712_DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class MultiplexOtc__factory {
  static readonly abi = _abi;
  static createInterface(): MultiplexOtcInterface {
    return new utils.Interface(_abi) as MultiplexOtcInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MultiplexOtc {
    return new Contract(address, _abi, signerOrProvider) as MultiplexOtc;
  }
}
